import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'

const StoryTwo = ({
  className,
  rightClassName,
  leftClassName,
  left,
  right,
  ...props
}) => (
  <Grid
    spacing={8}
    classes={{ container: className }}
    justify="center"
    alignItems="center"
    {...props}
    container
  >
    <Grid classes={{ item: rightClassName }} item>
      {right}
    </Grid>
    <Grid classes={{ item: leftClassName }} item>
      {left}
    </Grid>
  </Grid>
)

StoryTwo.propTypes = {
  className: PropTypes.string.isRequired,
  leftClassName: PropTypes.string.isRequired,
  rightClassName: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  left: PropTypes.node.isRequired,
  right: PropTypes.node.isRequired,
}

export default StoryTwo



// WEBPACK FOOTER //
// ./src/components/Storiespage/StoryTwo.js